module.exports = __webpack_public_path__ + "static/media/forma-pago-v2.107d0331.jpeg";